import React from "react";
import { useSelector } from "react-redux";
import { Route } from "react-router-dom";
import { urls } from "../../config/routes";
import GalleryHandler from "../../components/GalleryHandler";

const MedicalRecordsRoutes = () => {
  const { data } = useSelector(state => state.medicalRecords);
  return (
    <Route
      path={urls.medicalRecordDetail}
      exact
      render={renderProps =>
        data &&
        data.length > 0 && (
          <GalleryHandler
            {...renderProps}
            data={data}
            defaultRoute={urls.medicalRecords}
            detailRoute={urls.medicalRecordDetail}
            view="medicalRecords"
          />
        )
      }
    />
  );
};

export default MedicalRecordsRoutes;
